var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolunteer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Volunteer_Icon",
    "data-name": "Volunteer Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3517",
    "data-name": "Rectangle 3517",
    width: 32,
    height: 32,
    rx: 7,
    transform: "translate(0 32) rotate(-90)",
    fill: "#ddd",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Volunteer_Icon-2",
    "data-name": "Volunteer Icon",
    d: "M32.1,5.428a1.173,1.173,0,0,0-1.314,1.036l-.632,5.305a.362.362,0,0,1-.379.328H29.75a.367.367,0,0,1-.354-.379l.3-6.9a1.188,1.188,0,0,0-2.375-.1l-.3,6.9a.367.367,0,0,1-.379.354.38.38,0,0,1-.354-.354l-.505-8.008a1.19,1.19,0,0,0-2.375.152l.48,7.68a.335.335,0,0,1-.379.379h-.126a.374.374,0,0,1-.354-.3l-1.086-6.29a1.176,1.176,0,0,0-1.364-.96,1.158,1.158,0,0,0-.96,1.364s.935,5.128,1.086,6.214a26.927,26.927,0,0,1,.253,2.7c.025.556-.429.909-.985.379,0,0-1.01-1.238-1.592-1.844a1.382,1.382,0,0,0-1.819-.429,1.3,1.3,0,0,0-.379,1.869,53.524,53.524,0,0,0,4.143,5.937,5.293,5.293,0,0,0,1.794,1.389l.328,3.764a.963.963,0,0,0,.96.884h5.2a.945.945,0,0,0,.96-.884l.328-3.865c1.516-.682,1.617-2.8,1.92-5,.379-2.678,1.314-10,1.314-10A1.191,1.191,0,0,0,32.1,5.428Zm-3.562,12.3L26.39,19.878a.275.275,0,0,1-.379,0l-2.122-2.122a1.475,1.475,0,0,1-.328-1.667,1.418,1.418,0,0,1,2.3-.379l.328.328.278-.278a1.475,1.475,0,0,1,1.667-.328A1.408,1.408,0,0,1,28.537,17.73Z",
    transform: "translate(-8.942 1.504)",
    fill: "#4d9cc1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteer);
export default __webpack_public_path__ + "static/media/volunteer.fe1db58cc8255c12b09101582d29c8ae.svg";
export { ForwardRef as ReactComponent };